import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import NavigationSidebar from '@/components/common/navigationSidebar/NavigationSidebar.vue';

import { useNavigationStore } from '@/stores/navigation.store';
import { computed } from 'vue';
import { useAppStore } from '@/stores/app.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAreaNavigationSidebar',
  setup(__props) {

const navigationStore = useNavigationStore();
const appStore = useAppStore();

const items = computed(() => {
  return appStore?.isMobile ? [] : navigationStore.sidebarNavigationMenu;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigationSidebar, {
    dir: _unref(appStore).dir,
    items: items.value,
    options: _unref(navigationStore).getDrawerOptions
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["dir", "items", "options"]))
}
}

})